module.exports = __webpack_public_path__ + "media/images/grip_lines-da6d09e2.svg";